import { 
    apiGetAllQuestions,
    apiAddQuestionToDeck, 
    apiFetchAvailableQuestions, 
    apiGetQuestion, apiGetSingleQuestion,
    apiPutResponse, apiRemoveQuestion,
    apiGetSkipQuestion,
    apiGetQuestionResults,
    apiPutNextReviewDate,
    apiCompleteTest,
    apiAnswerQuestion,
    apiSimulateResponse
} from "../api";
import { 
    GET_QUESTION_RESULTS, GET_QUESTION_RESULTS_FAILED, 
    GET_SKIP_QUESTION, GET_SKIP_QUESTION_FAILED, 
    GET_QUESTION_COUNT, GET_QUESTION_COUNT_FAILED, 
    ADD_QUESTION_TO_DECK, ADD_QUESTION_TO_DECK_FAILED, 
    FETCH_AVAILABLE_QUESTIONS, FETCH_AVAILABLE_QUESTIONS_FAILED, 
    GET_QUESTION, GET_QUESTION_FAILED, 
    PUT_RESPONSE, PUT_RESPONSE_FAILED, 
    PUT_NEXT_REVIEW_RESPONSE, PUT_NEXT_REVIEW_RESPONSE_FAILED,
    COMPLETE_SASP_TEST, COMPLETE_SASP_TEST_FAIL,
    REMOVE_QUESTION_FROM_DECK, REMOVE_QUESTION_FROM_DECK_FAILED
} from "./types";

export const submitCME = (data) => async dispatch => {
    try {
        let response = await apiCompleteTest(data);

        dispatch({
            type: COMPLETE_SASP_TEST,
            payload: response
        });
    } catch (e) {
        dispatch({
            type: COMPLETE_SASP_TEST_FAIL,
            payload: e
        });
    }
}

export const getQuestion = (data, type) => async dispatch => {
    try {
        let response = await apiGetQuestion(data, type);

        // console.log(`data: `, data, `\nresponse: `,response)

        dispatch({
            type: GET_QUESTION,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: GET_QUESTION_FAILED,
            payload: error
        });
    }
};

export const removeQuestion = (data) => async dispatch => {
    try {
        let repsonse = await apiRemoveQuestion(data);
        dispatch({
            type: REMOVE_QUESTION_FROM_DECK,
            payload: repsonse
        });

    } catch(error) {
        dispatch({
            type: REMOVE_QUESTION_FROM_DECK_FAILED,
            payload: error
        });
    }
};

export const getSingleQuestion = (data, type) => async dispatch => {
    try {
        let response = await apiGetSingleQuestion(data, type);
        dispatch({
            type: GET_QUESTION,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: GET_QUESTION_FAILED,
            payload: error
        });
    }
};

export const getQuestionResults = (data, type) => async dispatch => {
    try {
        let response = await apiGetQuestionResults(data, type);

        // console.log(`getQuestion Results \ndata: `, data, `\nresponse: `,response)

        dispatch({
            type: GET_QUESTION_RESULTS,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: GET_QUESTION_RESULTS_FAILED,
            payload: error
        });
    }
};

export const skipThisQuestion = (data, type) => async dispatch => {
    try {
        let obj = await apiGetSkipQuestion(data);
        dispatch({
            type: GET_SKIP_QUESTION,
            payload: obj
        });
    } catch (e) {
        dispatch({
            type: GET_SKIP_QUESTION_FAILED,
            payload: e
        });
    }
}

export const simulateResponse = data => async dispatch => {
    try {
        let response = await apiSimulateResponse(data);

        return response;
    } catch (e) {
    }
}

export const putResponse = data => async dispatch => {
    try {
        let response = await apiPutResponse(data);

        dispatch({
            type: PUT_RESPONSE,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: PUT_RESPONSE_FAILED,
            payload: error
        });
    }
};

export const fetchAvailableQuestions = (data) => async dispatch => {
    try{
        let fetchAvailableQuestionsResponse = await apiFetchAvailableQuestions(data);
        dispatch({
            type: FETCH_AVAILABLE_QUESTIONS,
            payload: fetchAvailableQuestionsResponse
        });
    } catch (error) {
        dispatch({
            type: FETCH_AVAILABLE_QUESTIONS_FAILED,
            payload: error
        });
    }
};

export const getAllQuestions = (data) => async dispatch => {
    try {
        let getAllQuestionCountResponse = await apiGetAllQuestions(data);
        dispatch({
            type: GET_QUESTION_COUNT,
            payload: getAllQuestionCountResponse
        });
    } catch (error) {
        dispatch({
            type: GET_QUESTION_COUNT_FAILED,
            payload: error
        });
    }
};

export const addQuestionToDeck = (data) => async dispatch => {
    try {
        let response = await apiAddQuestionToDeck(data);
        dispatch({
            type: ADD_QUESTION_TO_DECK,
            payload: response
        });

    } catch(error) {
        dispatch({
            type: ADD_QUESTION_TO_DECK_FAILED,
            payload: error
        });
    }
};

export const putNextReviewDate = data => async dispatch => {
    try {
        let put = await apiPutNextReviewDate(data);
        dispatch({
            type: PUT_NEXT_REVIEW_RESPONSE,
            payload: put
        });
    } catch (error) {
        dispatch({
            type: PUT_NEXT_REVIEW_RESPONSE_FAILED,
            payload: error
        });
    }
};

export const answerQuestion = data => async dispatch => {
    try {
        let response = await apiAnswerQuestion(data);
        dispatch({
            type: PUT_RESPONSE,
            payload: response
        });
    } catch (error) {
        dispatch({
            type: PUT_RESPONSE_FAILED,
            payload: error
        });
    }
};